import axios from 'axios'
import config from '../config'

const Product = {
    state: {
        productList: [],
        productDetail: [],
        error: false,
        msg: ''
    },
    mutations: {
        ProductList: (state, productList) => state.productList = productList,
        ProductDetail: (state, productDetail) => state.productDetail = productDetail,
        ERROR: (state, error) => state.error = error,
        MSG: (state, msg) => state.msg = msg
    },
    actions: {
    async  fetchProductList({commit}, data){
        await axios({
            method:'post',
            url: config.LOAD_PRODUCT_LIST,
            data: data
        })
        .then((result) => {
            commit('ProductList', result.data.products)
        }).catch((err) => {
            console.log(err);
        });
    },
    async fetchProductDetail({commit}, data){
        await axios({
            method:'post',
            url: config.LOAD_PRODUCT_DETAIL,
            data: data
        })
        .then((result) => {
            commit('ProductDetail', result.data.data)
        }).catch((err) => {
            console.log(err);
        });
    },
    async addProduct({commit}, data){
        await axios({
            method:'post',
            url: config.ADD_PRODUCT,
            data: data
        })
        .then((result) => {
            commit('ERROR', result.data.error)
            commit('MSG', result.data.msg)
        }).catch((err) => {
            console.log(err);
        });
    },
    async productUpdate({commit}, data){
        await axios({
            method:'post',
            url: config.PRODUCT_UPDATE,
            data: data
        })
        .then((result) => {
            commit('ERROR', result.data.error),
            commit('MSG', result.data.msg)
        }).catch((err) => {
            console.log(err);
        });
    },
    async productUpdateStatus({commit}, data){
        await axios({
            method:'post',
            url: config.PRODUCT_UPDATE_STATUS,
            data: data
        })
        .then((result) => {
            commit('ERROR', result.data.error)
            commit('MSG', result.data.msg)
        }).catch((err) => {
            console.log(err);
        });
    }
    },
    getters: {
        getProductList: state => state.productList,
        getProductDetail: state => state.productDetail,
        getProductError: state => state.error,
        getProductMsg: state => state.msg
    }
}

export default Product;